module.exports = __webpack_public_path__ + "static/img/top-content.3a164cb5.png";